import React from 'react';
import DistributorBank from '../distributor/DistributorBank';
import DistributorBankAlerts from '../DistributorBankAlerts';

// A cash account never inherits unit-family warnings or their legacy side column.
export default function CashBankSection({ active, refresh, t, readOnly }) {
  return (
    <div
      id="distributor-bank"
      role="region"
      aria-label={t('Tissue bank page')}
      hidden={!active}
      className="me-dw-section me-dw-bank-layout"
    >
      <DistributorBank key={`bank-${refresh}`} {...{ t, readOnly }} />
      <div className="me-dw-bank-aside">
        <DistributorBankAlerts cash {...{ readOnly, t }} />
      </div>
    </div>
  );
}
